const init = Date.now();

export default function now(): number {
  return typeof performance !== 'undefined'
    ? performance.now()
    : Date.now() - init;
}
